import { render } from "./profession-selection-modal.vue?vue&type=template&id=70b7aa70"
import script from "./profession-selection-modal.vue?vue&type=script&lang=js"
export * from "./profession-selection-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__